export enum TypeOfEtity {
	Kategorija = 1,
	Podkategorija = 2,
	SkupOblasti = 3,
	Oblast = 4,
	Podoblast = 5,
	Lekcija = 6,
	Pitanje = 7,
}
